module.exports = __webpack_public_path__ + "static/media/kodiranePlombe1.d7075220.JPG";